export default __webpack_public_path__ + "static/media/dining1.06b406cc.JPG";